import React from "react"

import { StrategyPineDetailDialog } from "@/components/Strategies/StrategyPineDetailDialog"
import { Button } from "@/components/ui/button"
import { Field, FieldDescription, FieldLabel } from "@/components/ui/field"
import { Input } from "@/components/ui/input"

import { DashboardLayoutDialogFooter } from "./DashboardLayoutDialogFooter"
import {
  DASHBOARD_LAYOUT_FIELD_DESC_CLASS,
  DASHBOARD_LAYOUT_FIELD_LABEL_CLASS,
} from "./dashboardLayoutUi"

export interface DashboardDeleteLayoutDialogProps {
  open: boolean
  layoutName: string
  confirmText: string
  onConfirmTextChange: (value: string) => void
  onOpenChange: (open: boolean) => void
  onCancel: () => void
  onConfirmDelete: () => void
}

const DashboardDeleteLayoutDialog: React.FC<DashboardDeleteLayoutDialogProps> = ({
  open,
  layoutName,
  confirmText,
  onConfirmTextChange,
  onOpenChange,
  onCancel,
  onConfirmDelete,
}) => {
  const confirmMatches = confirmText.trim() === layoutName.trim()

  return (
    <StrategyPineDetailDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onCancel()
        onOpenChange(nextOpen)
      }}
      title="Delete layout"
      showHeader={false}
      showDismissButton={false}
      contentClassName="sm:max-w-md"
      bodyClassName="flex-none overflow-visible"
      footer={
        <DashboardLayoutDialogFooter onCancel={onCancel}>
          <Button
            type="button"
            variant="outline"
            size="sm"
            data-font="primary"
            data-trade-log-action="delete"
            className="shrink-0 border-destructive/40 text-destructive shadow-sm hover:bg-destructive/10 hover:text-destructive focus-visible:border-destructive/60 focus-visible:ring-destructive/25 dark:border-destructive/50 dark:hover:bg-destructive/15 [&_svg]:text-current"
            disabled={!confirmMatches}
            onClick={onConfirmDelete}
          >
            <span data-font="primary">Delete layout</span>
          </Button>
        </DashboardLayoutDialogFooter>
      }
    >
      <Field className="gap-2">
        <FieldLabel htmlFor="dashboard-layout-delete-confirm-input" className={DASHBOARD_LAYOUT_FIELD_LABEL_CLASS}>
          Type layout name to confirm
        </FieldLabel>
        <FieldDescription className={DASHBOARD_LAYOUT_FIELD_DESC_CLASS}>
          This permanently removes the layout and its card arrangement. Enter{" "}
          <span className="font-medium text-[#6b7280]">{layoutName}</span> exactly to confirm.
        </FieldDescription>
        <Input
          id="dashboard-layout-delete-confirm-input"
          value={confirmText}
          onChange={(event) => onConfirmTextChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Escape") onCancel()
          }}
          autoComplete="off"
          placeholder={layoutName}
          data-font="primary"
        />
      </Field>
    </StrategyPineDetailDialog>
  )
}

export default DashboardDeleteLayoutDialog
